<template>
  <div>
    <textarea
      :id="contentId"
      v-model="contentTxt"
    >
    </textarea>

    <v-dialog v-model="dialogEmoji" scrollable persistent max-width="320">
      <v-card>
        <v-card-title class="primary white--text">
          <div class="title">
            <v-btn icon @click="dialogEmoji = false"><v-icon class="white--text">close</v-icon></v-btn>
            emoji
          </div>
        </v-card-title>
        <v-card-text>
          <!-- EMOJI LISTE-->
          <Picker
            :data="emojiIndex"
            native
            :perLine="8"
            :sheetSize="18"
            :emojiSize="20"
            :showSearch="true"
            :showPreview="false"
            :showSkinTones="true"
            :showCategories="true"
            :color="$vuetify.theme.secondary"
            :i18n="i18nPicker"
            @select="addEmoji"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            @click="dialogEmoji = false"
          >Annuler</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    
  </div>
</template>



<script>
// import _ from 'lodash'
import data from 'emoji-mart-vue/data/all.json'
import 'emoji-mart-vue-fast/css/emoji-mart.css'
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast'
import suneditor from 'suneditor'
import 'suneditor/dist/css/suneditor.min.css'
// import plugins from 'suneditor/src/plugins'
import {
  align,
  link,
  table,
  lineHeight,
  horizontalRule,
  formatBlock,
  hiliteColor,
  fontColor,
  fontSize,
  list,
  font,
  video
} from 'suneditor/src/plugins'
// How to import language files (default: en)
import lang from 'suneditor/src/lang'
// import {fr, en} from 'suneditor/src/lang'

const exclude = ['flags', 'symbols', 'custom']
let emojiIndex = new EmojiIndex(data, {exclude})

export default {
  props: {
    contentTxt: {
      type: String,
      default: 'text par defaut'
    },
    maxChar: {
      type: Number,
      default: 256
    },
    contentId: {
      type: String,
      default: 'txt'
    },
    lang: {
      type: String,
      default: 'en'
    },
    nodeIndex: {
      type: Number,
      default: 0
    },
    nodeTypeTextIndex: {
      type: Number,
      default: 0
    },
    nodeOption: {
      type: Number,
      default: 0
    },
    typeMenu: {
      type: String,
      default: 'default'
    }
  },

  data () {
    return {
      editor: null,
      dialogEmoji: false,
      contentSelected: '',
      lineStart: '',
      lineEnd: '',
      pluginSubmenu: {},
      pluginEmoji: {},
      emojiIndex: emojiIndex,
      i18nPicker: {
        search: 'rechercher',
        notfound: 'Aucun Emoji Trouvé',
        categories: {
          search: 'Résultats Recherche',
          recent: 'Fréquemment utilisé',
          people: 'Smileys & Personnes',
          nature: 'Animaux & Nature',
          foods: 'Nourriture & Boisson',
          activity: 'Activité',
          places: 'Voyages & Endroits',
          objects: 'Objets',
          symbols: 'Symboles',
          flags: 'Drapeaux'
        }
      }
    }
  },
  components: {Picker},
  computed: {
    langage () {
      if (this.lang === 'fr') {
        return lang.fr
      } else if (this.lang === 'es') {
        return lang.es
      } else {
        return lang.en
      }
    },
    buttonList () {
      // console.log('-----> buttonList = this.typeMenu ', this.typeMenu )
      if (this.typeMenu === 'options') {
        // console.log('-----> this.typeMenu ', this.typeMenu )
        return [
          ['undo', 'redo', 'removeFormat', 'codeView', 'insertEmoji']
        ]
      } else {
        // console.log('-----> this.typeMenu ', this.typeMenu )
        return [
          // default
          ['undo', 'redo'],
          [':p-More Paragraph-default.more_paragraph', 'font', 'fontSize', 'formatBlock'],
          [':t-More Text-default.more_text', 'bold', 'underline', 'italic', 'strike', 'subscript', 'superscript', 'fontColor', 'hiliteColor', 'removeFormat'],
          [':e-More Line-default.more_horizontal', 'outdent', 'indent', 'align', 'horizontalRule', 'list', 'lineHeight'],
          [':r-More Rich-default.more_plus', 'table', 'link', 'insertUrlImage', 'video', 'insertEmoji'],
          ['-right', ':i-More Misc-default.more_vertical', 'fullScreen', 'showBlocks', 'codeView']
        ]
      }
    }
  },
  created () {
    // console.log('mcreated this.contentId', this.contentId)
  },
  mounted () {
    // let parent = this
    // console.log('mounted this.contentId', this.contentId)
    this.init()
  },
  updated () {
    // console.log('updated this.contentId', this.contentId)
  },
  watch: {},
  methods: {
    init () {
      let parent = this
      // -----------------------------------------------------------------------
      // ------------------ plugin d'ajout d'image avec code html simplifié
      // -----------------------------------------------------------------------
      this.pluginSubmenu = {
        // @Required @Unique
        // plugin name
        name: 'insertUrlImage',

        // @Required
        // data display
        display: 'submenu',

        // @Options
        title: 'Ajouter une image',
        buttonClass: '',
        innerHTML: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.75 15.77"><g><path d="M8.77,8.72a.88.88,0,0,1-.61-.27.82.82,0,0,1-.25-.61.89.89,0,0,1,.25-.62A.82.82,0,0,1,8.77,7a.81.81,0,0,1,.61.25.83.83,0,0,1,.27.62.81.81,0,0,1-.25.61.91.91,0,0,1-.63.27Zm9.62-5a1.74,1.74,0,0,1,1.76,1.76V17.76a1.74,1.74,0,0,1-1.76,1.76H6.16A1.74,1.74,0,0,1,4.4,17.76V5.51A1.74,1.74,0,0,1,6.16,3.75H18.39Zm0,1.75H6.16v8L8.53,11.8a.94.94,0,0,1,.54-.17.86.86,0,0,1,.54.2L11.09,13l3.64-4.55a.78.78,0,0,1,.34-.25.85.85,0,0,1,.42-.07.89.89,0,0,1,.39.12.78.78,0,0,1,.28.29l2.24,3.67V5.51Zm0,12.24V15.6L15.3,10.53,11.89,14.8a.89.89,0,0,1-.59.32.82.82,0,0,1-.64-.18L9,13.62,6.16,15.74v2Z" transform="translate(-4.4 -3.75)"></path></g></svg>',

        // @Required
        // add function - It is called only once when the plugin is first run.
        // This function generates HTML to append and register the event.
        // arguments - (core : core object, targetElement : clicked button element)
        add: function (core, targetElement) {
          // @Required
          // Registering a namespace for caching as a plugin name in the context object
          const context = core.context
          context.customSubmenu = {
            targetButton: targetElement,
            textElement: null,
            currentSpan: null
          }

          // Generate submenu HTML
          // Always bind "core" when calling a plugin function
          let listDiv = this.setSubmenu(core)

          // Input tag caching
          context.customSubmenu.textElement = listDiv.querySelector('input')

          // You must bind "core" object when registering an event.
          /** add event listeners */
          listDiv.querySelector('.se-btn-primary').addEventListener('click', this.onClick.bind(core))
          listDiv.querySelector('.se-btn').addEventListener('click', this.onClickRemove.bind(core))

          // @Required
          // You must add the "submenu" element using the "core.initMenuTarget" method.
          /** append target button menu */
          core.initMenuTarget(this.name, targetElement, listDiv)
        },

        setSubmenu: function (core) {
          const listDiv = core.util.createElement('DIV')
          // @Required
          // A "se-submenu" class is required for the top level element.
          listDiv.className = 'se-menu-container se-submenu se-list-layer'
          listDiv.innerHTML = '' +
            '<div class="se-list-inner">' +
                '<ul class="se-list-basic" style="width: 300px;">' +
                    '<li>' +
                        '<div class="se-form-group">' +
                            '<input class="se-input-form" type="text" placeholder="Copier l\'URL de l\'image ici" style="border: 1px solid #CCC;" />' +
                            '<button type="button" class="se-btn-primary se-tooltip se-btn se-btn-more">' +
                                '<strong>OK</strong>' +
                                '<span class="se-tooltip-inner">' +
                                    '<span class="se-tooltip-text">sauvegarder</span>' +
                                '</span>' +
                            '</button>' +
                            '<button type="button" class="se-btn se-tooltip se-btn se-btn-more">' +
                                '<strong>X</strong>' +
                                '<span class="se-tooltip-inner">' +
                                    '<span class="se-tooltip-text">Remove</span>' +
                                '</span>' +
                            '</button>' +
                        '</div>' +
                    '</li>' +
                '</ul>' +
            '</div>'
          return listDiv
        },

        // @Override core
        // Plugins with active methods load immediately when the editor loads.
        // Called each time the selection is moved.
        active (element) {
          // If no tag matches, the "element" argument is called with a null value.
          if (!element) {
            this.util.removeClass(this.context.customSubmenu.targetButton, 'active')
            this.context.customSubmenu.textElement.value = ''
            this.context.customSubmenu.currentSpan = null
          } else if (this.util.hasClass(element, 'se-custom-tag')) {
            this.util.addClass(this.context.customSubmenu.targetButton, 'active')
            this.context.customSubmenu.textElement.value = element.textContent
            this.context.customSubmenu.currentSpan = element
            return true
          }
          return false
        },

        // @Override submenu
        // Called after the submenu has been rendered
        on: function () {
          this.context.customSubmenu.textElement.focus()
        },

        onClickRemove: function () {
          const span = this.context.customSubmenu.currentSpan
          if (span) {
            this.util.removeItem(span)
            this.context.customSubmenu.currentSpan = null

            this.submenuOff()
            this.focus()
          }
        },

        onClick: function () {
          const value = this.context.customSubmenu.textElement.value.trim()
          if (!value) return
          const span = this.context.customSubmenu.currentSpan
          if (span) {
            span.textContent = value
            this.setRange(span, 1, span, 1)
          } else {
            this.functions.insertHTML('<img src="' + value + '" alt="" class="tf-imgChat" style="width: 200px;" >', true)
            this.context.customSubmenu.textElement.value = ''
          }
          this.submenuOff()
        }
      }

      // -----------------------------------------------------------------------
      // ------------------------ plugin emoji
      // -----------------------------------------------------------------------
      this.pluginEmoji = {
        // @Required @Unique
        // plugin name
        name: 'insertEmoji',

        // @Required
        // data display
        display: 'command',

        // @Options
        title: 'Ajouter une emoji',
        buttonClass: '',
        innerHTML: '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><circle cx="15.5" cy="9.5" r="1.5"/><circle cx="8.5" cy="9.5" r="1.5"/><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-5-6c.78 2.34 2.72 4 5 4s4.22-1.66 5-4H7z"/></svg>',

        // @Required
        // add function - It is called only once when the plugin is first run.
        // This function generates HTML to append and register the event.
        // arguments - (core : core object, targetElement : clicked button element)
        add: function (core, targetElement) {
          // console.log('add', targetElement)
          const context = core.context
          const rangeTag = null
          // core.util.addClass(rangeTag, '__se__format__range_custom')
          // @Required
          // Registering a namespace for caching as a plugin name in the context object
          context.customCommand = {
            targetButton: targetElement,
            tag: rangeTag,
            textElement: null,
            currentSpan: null
          }
        },

        // @Override core
        // Plugins with active methods load immediately when the editor loads.
        // Called each time the selection is moved.
        active: function (element) {
          // console.log('active', element)
          if (!element) {
            // this.util.removeClass(this.context.customCommand.targetButton, 'active')
            this.context.customCommand.textElement = ''
            this.context.customCommand.currentSpan = null
          } else {
            // this.util.addClass(this.context.customCommand.targetButton, 'active')
            this.context.customCommand.textElement = element.textContent
            // console.log('this.context.customCommand.textElement', this.context.customCommand.textElement)
            parent.contentSelected = element.innerHTML
            this.context.customCommand.currentSpan = element
            parent.getWord()
            return true
          }
          return false
        },

        // @Required, @Override core
        // The behavior of the "command plugin" must be defined in the "action" method.
        action: function () {
          // console.log('action', this.context.customCommand.textElement)
          // const value = this.context.customCommand.textElement.value.trim()
          // console.log('action', value)
          parent.dialogEmoji = true // affiche la dialogBox emoji
          // const rangeTag = this.util.getRangeFormatElement(this.getSelectionNode())
          // if (this.util.hasClass(rangeTag, '__se__format__range_custom')) {
          //   this.detachRangeFormatElement(rangeTag, null, null, false, false)
          // } else {
          //   this.applyRangeFormatElement(this.context.customCommand.tag.cloneNode(false))
          // }
        }
      }
      // --- suneditor ---//
      this.editor = suneditor.create(this.contentId, {
        // plugins: plugins,
        plugins: [
          this.pluginSubmenu,
          this.pluginEmoji,
          font,
          video,
          list,
          fontSize,
          formatBlock,
          fontColor,
          hiliteColor,
          align,
          horizontalRule,
          lineHeight,
          table,
          link
        ],
        charCounter: true,
        maxCharCount: this.maxChar,
        charCounterType: 'byte-html',
        width: '100%',
        minHeight: 300,
        imageFileInput: false, // bloque le telechargement d'une image du disque dur
        // imageGalleryUrl: 'https://etyswjpn79.execute-api.ap-northeast-1.amazonaws.com/suneditor-demo',
        buttonList: parent.buttonList,
        lang: parent.langage
        // callBackSave: function (contents, isChanged) {
        //   console.log('contents', contents)
        //   console.log('isChanged', isChanged)
        // }
      })
      // this.editor.onInput = function (e) { console.log('onInput', e) }
      this.editor.onChange = ((contents) => {
        // console.log('onChange', contents)
        this.changeTxt(contents)
      })
      this.editor.toggleCodeView = ((isCodeView) => {
        // console.log('toggleCodeView', isCodeView)
        this.toggleHTML(isCodeView)
      })
      this.editor.setDefaultStyle('font-family: verdana; font-size: 16px;')
      
      // ------------------------------- //
    },
    changeTxt (contents) {
      // console.log('changeTxt', contents)
      this.$emit('changeContent', {'content': contents, 'node': this.nodeIndex, 'option': this.nodeOption, 'nodeTypeText': this.nodeTypeTextIndex})
    },
    toggleHTML (isCodeView) {
      // console.log('toggleHTML', isCodeView)
      this.$emit('toggleCodeView', {'isCodeView': isCodeView})
    },
    // ----------------------------------------------------------------------------
    // Ajoute l'emoji dans le textarea
    // ----------------------------------------------------------------------------
    addEmoji (emoji) {
      this.dialogEmoji = false
      // console.log('selected content ', this.contentSelected)
      // console.log('addEmoji', emoji.native)
      // console.log('editor', this.editor.getText())
      // console.log('content', this.contentTxt)
      // ajout l'emoji au contenu selectionné
      // let newTxt = this.contentSelected.trim() + ' ' + emoji.native
      let oldTxt = this.lineStart + this.lineEnd
      let newTxt = this.lineStart + emoji.native + this.lineEnd
      // remplace l'ancien contenu par le nouveau avec emoji
      let contentReplace = this.contentTxt.replace(oldTxt.trim(), newTxt.trim())
      // remplce dans l'editeur le contenu modifié
      this.editor.setContents(contentReplace)
    },
    // ----------------------------------------------------------------------------
    // retour la placement du curseur dans la phrase
    // ----------------------------------------------------------------------------
    getWord () {
      let sel
      this.lineStart = ''
      if (window.getSelection && (sel = window.getSelection()).modify) {
        let selectedRange = sel.getRangeAt(0)
        sel.collapseToStart()
        // sel.modify('move', 'backward', 'word')
        sel.modify('extend', 'backward', 'sentenceboundary')
        this.lineStart = sel.toString()
        // Restore selection
        sel.removeAllRanges()
        sel.addRange(selectedRange)
      } else if ((sel = document.selection) && sel.type !== 'Control') {
        var range = sel.createRange()
        range.collapse(true)
        range.expand('word')
        this.lineStart = range.text
      }
      let sel2
      this.lineEnd = ''
      if (window.getSelection && (sel2 = window.getSelection()).modify) {
        let selectedRange = sel2.getRangeAt(0)
        sel2.collapseToEnd()
        // sel2.modify('move', 'forward', 'word')
        sel2.modify('extend', 'forward', 'sentenceboundary')
        this.lineEnd = sel2.toString()
        // Restore selection
        sel2.removeAllRanges()
        sel2.addRange(selectedRange)
      }
      // console.log('lineStart', this.lineStart)
      // console.log('lineEnd', this.lineEnd)
    }
  }
}
</script>

